// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.RentalManagerUserPropertyMultiplexWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyMultiplexCreateUnitsRequestWebDto,
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  UserPropertyMultiplexSetListingCriteriaRequestWebDto,
  UserPropertyMultiplexSetListingCriteriaResponseWebDto,
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  UserPropertyMultiplexUpdateRequestWebDto,
  UserPropertyMultiplexUpdateResponseWebDto,
} from '../..';

interface DetailsParams {
  multiplexBuildingSessionId: string;
}
interface GetUnitNumbersParams {
  fullAddress: string;
}
interface OverviewParams {
  multiplexBuildingSessionId: string;
}
interface UnitPublishedParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId: string;
}

export const RentalManagerUserPropertyMultiplexWebApiHandler_create_Path =
  '/api/web/v1/users/properties/multiplex/create';

/**
 * Create units for a multiplex
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_create = (
  postData: UserPropertyMultiplexCreateUnitsRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexCreateUnitsRequestWebDto,
    UserPropertyMultiplexCreateUnitsResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_details_Path =
  '/api/web/v1/users/properties/multiplex/details';

/**
 * Get property details for a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_details = (
  getParams: DetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DetailsParams, never, UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path =
  '/api/web/v1/users/properties/multiplex/getUnitNumbers';

/**
 * Get unit numbers for a multiplex
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers = (
  getParams: GetUnitNumbersParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUnitNumbersParams, never, UserPropertyMultiplexGetUnitNumbersResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path =
  '/api/web/v1/users/properties/multiplex/overview';

/**
 * Get overview for a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_overview = (
  getParams: OverviewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OverviewParams, never, UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Path =
  '/api/web/v1/users/properties/multiplex/setListingCriteria';

/**
 * Set listing criteria for all the units in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria = (
  postData: UserPropertyMultiplexSetListingCriteriaRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexSetListingCriteriaRequestWebDto,
    UserPropertyMultiplexSetListingCriteriaResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Path,
      method: 'PUT',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path =
  '/api/web/v1/users/properties/multiplex/unitPublished';

/**
 * Get publish summary after a multiplex unit is published
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished = (
  getParams: UnitPublishedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnitPublishedParams, never, UserPropertyMultiplexUnitPublishedResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_update_Path =
  '/api/web/v1/users/properties/multiplex/update';

/**
 * Update listing fields for all the units in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_update = (
  postData: UserPropertyMultiplexUpdateRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexUpdateRequestWebDto,
    UserPropertyMultiplexUpdateResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_update_Path,
      method: 'PUT',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
